import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "cat-select" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = ["alt"]
const _hoisted_4 = ["alt"]
const _hoisted_5 = ["alt"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "artifact-list" }
const _hoisted_8 = { style: {"margin-top":"10px"} }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { style: {"margin-top":"10px"} }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArtifactItem = _resolveComponent("ArtifactItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          class: "hidden",
          type: "radio",
          value: "1",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.artifactCatTabSelected) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.catOnChange && _ctx.catOnChange(...args)))
        }, null, 544), [
          [_vModelRadio, _ctx.artifactCatTabSelected]
        ]),
        _createElementVNode("img", {
          src: "images/flower_of_life.png",
          alt: _ctx.displayName('生の花')
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          class: "hidden",
          type: "radio",
          value: "2",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.artifactCatTabSelected) = $event)),
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.catOnChange && _ctx.catOnChange(...args)))
        }, null, 544), [
          [_vModelRadio, _ctx.artifactCatTabSelected]
        ]),
        _createElementVNode("img", {
          src: "images/plume_of_death.png",
          alt: _ctx.displayName('死の羽')
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          class: "hidden",
          type: "radio",
          value: "3",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.artifactCatTabSelected) = $event)),
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.catOnChange && _ctx.catOnChange(...args)))
        }, null, 544), [
          [_vModelRadio, _ctx.artifactCatTabSelected]
        ]),
        _createElementVNode("img", {
          src: "images/sands_of_eon.png",
          alt: _ctx.displayName('時の砂')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          class: "hidden",
          type: "radio",
          value: "4",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.artifactCatTabSelected) = $event)),
          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.catOnChange && _ctx.catOnChange(...args)))
        }, null, 544), [
          [_vModelRadio, _ctx.artifactCatTabSelected]
        ]),
        _createElementVNode("img", {
          src: "images/goblet_of_eonothem.png",
          alt: _ctx.displayName('空の杯')
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          class: "hidden",
          type: "radio",
          value: "5",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.artifactCatTabSelected) = $event)),
          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.catOnChange && _ctx.catOnChange(...args)))
        }, null, 544), [
          [_vModelRadio, _ctx.artifactCatTabSelected]
        ]),
        _createElementVNode("img", {
          src: "images/circlet_of_logos.png",
          alt: _ctx.displayName('理の冠')
        }, null, 8, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artifactOwnArrCatId(_ctx.artifactCatTabSelected), (item) => {
        return (_openBlock(), _createBlock(_component_ArtifactItem, {
          key: item.id,
          artifact: item.artifact,
          id: item.id,
          control: _ctx.artifactControl,
          selected: item.selected,
          "onUpdate:artifact": _ctx.updateArtifact,
          "onSelect:artifact": _ctx.selectArtifact
        }, null, 8, ["artifact", "id", "control", "selected", "onUpdate:artifact", "onSelect:artifact"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!_ctx.controlMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.removeOnClick && _ctx.removeOnClick(...args)))
            }, _toDisplayString(_ctx.displayName('削除')), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.newArtifactOnClick && _ctx.newArtifactOnClick(...args)))
            }, _toDisplayString(_ctx.displayName('新規聖遺物')), 1),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.reloadOnClick && _ctx.reloadOnClick(...args)))
            }, _toDisplayString(_ctx.displayName('最新')), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.controlMode == 'remove')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.selectCount == 0,
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.removeExecOnClick && _ctx.removeExecOnClick(...args)))
            }, _toDisplayString(_ctx.displayName('削除実行')), 9, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.removeModeEndProc && _ctx.removeModeEndProc(...args)))
            }, _toDisplayString(_ctx.displayName('キャンセル')), 1)
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.controlMode == 'new-artifact')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_ArtifactItem, {
              artifact: _ctx.newArtifact,
              id: 0,
              control: "editable",
              initial: true,
              "onUpdate:artifact": _ctx.updateArtifact
            }, null, 8, ["artifact", "onUpdate:artifact"]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.newArtifactAddOnClick && _ctx.newArtifactAddOnClick(...args))),
                disabled: !_ctx.addable
              }, _toDisplayString(_ctx.displayName('聖遺物追加')), 9, _hoisted_10),
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.newArtifactModeEndProc && _ctx.newArtifactModeEndProc(...args)))
              }, _toDisplayString(_ctx.displayName('キャンセル')), 1)
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.savable) = $event)),
          disabled: !_ctx.changed
        }, null, 8, _hoisted_12), [
          [_vModelCheckbox, _ctx.savable]
        ]),
        _createElementVNode("span", null, _toDisplayString(_ctx.displayName("聖遺物所持状況を保存する")), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
        disabled: !_ctx.savable
      }, _toDisplayString(_ctx.displayName("実行")), 9, _hoisted_13)
    ])
  ], 64))
}